import { getQuoteProperty } from 'quotes-ui-lib/utils/utils';
import { PROPOSAL, QUOTE, CUSTOMIZABLE_QUOTE_TEMPLATE } from '../constants/templates';
export function hasDeprecatedTemplateType(quote) {
  return [QUOTE, PROPOSAL].includes(getQuoteProperty(quote, 'hs_template_type'));
}
export function isProposalOrHasCustomTemplate(quote) {
  const templateType = getQuoteProperty(quote, 'hs_template_type');
  return templateType === PROPOSAL || templateType === CUSTOMIZABLE_QUOTE_TEMPLATE;
}